import { BrandEntityRaw } from "@common/domain";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { createReducer, on, Action } from "@ngrx/store";
import { BrandActions } from "../actions";

export const BRAND_FEATURE_KEY = "brand";

type BrandEntityJson1 = Omit<
  BrandEntityRaw,
  "logos" | "bgs" | "overlays" | "captionLowerThirds"
>;

export interface BrandState extends EntityState<BrandEntityJson1> {
  isLoading: boolean;
}

export const brandAdapter: EntityAdapter<BrandEntityJson1> =
  createEntityAdapter<BrandEntityJson1>({
    selectId: (_) => _.id,
    sortComparer: (lhs, rhs) => {
      return lhs.title.localeCompare(rhs.title);
    }
  });

export const initialBrandsState: BrandState = brandAdapter.getInitialState({
  isLoading: false
});

const reducer = createReducer(
  initialBrandsState,
  on(BrandActions.brandCreateSuccess, (state, { brand }) =>
    brandAdapter.addOne(brand.toJSON(), state)
  ),
  on(BrandActions.brandDeleteSuccess, (state, { brandId }) =>
    brandAdapter.removeOne(brandId, state)
  ),
  on(BrandActions.brandGetList, (state) => ({
    ...state,
    isLoading: true
  })),
  on(BrandActions.brandGetListFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(BrandActions.brandGetListSuccess, (state, { brands }) =>
    brandAdapter.setMany(
      brands.map((_) => _.toJSON()),
      {
        ...state,
        isLoading: false
      }
    )
  ),
  on(BrandActions.brandUpdateSuccess, (state, { brand }) =>
    brandAdapter.updateOne(
      {
        id: brand.value.id,
        changes: brand.toJSON()
      },
      state
    )
  )
);

export function brandReducer(state: BrandState | undefined, action: Action) {
  return reducer(state, action);
}
